// @ts-nocheck
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import cx from 'helpers/cx'

import ChatAvatar from 'js/chat/components/ChatAvatar'
import getChatContainer from 'js/chat/helpers/getChatContainer'
import { globalStateContext } from 'js/lib/GlobalState'

import styles from './NavigationChatItem.module.css'

const NavigationChatItem = ({ entity, onHide }) => {
    const { t } = useTranslation()

    const { unread, isNotificationPushEnabled } = entity

    const { setGlobalState } = useContext(globalStateContext)

    const openChat = () => {
        setGlobalState((newState) => {
            newState.activeMainThread = entity
        })
        onHide()
    }

    const container = getChatContainer(entity.container)

    if (!container) {
        console.error(t('error.chat-container-not-found'), entity)
        return null
    }

    return (
        <li className={styles.wrapper}>
            <button type="button" onClick={openChat} className={styles.button}>
                <ChatAvatar container={container} className={styles.avatar} />
                <div
                    className={cx(
                        styles.name,
                        unread && styles.isUnread,
                        !isNotificationPushEnabled && styles.muted,
                    )}
                >
                    {container.title}
                    {unread > 0 ? ` (${unread})` : null}
                </div>
            </button>
        </li>
    )
}

export default NavigationChatItem
